<template>
  <div>
    <div class="columns is-multiline"
         style="align-items: center; margin-left:0; margin-top:0; margin-right:0">

      <div style="align-items: center; margin-right:12px">
        <admin-date-picker
          style="display: inline-block"
          :data.sync="start_date"></admin-date-picker>
        <div class="lp-dating" style="margin-right:0">&#126;</div>
      </div>
      <div style="align-items: center;">
        <admin-date-picker
          style="display: inline-block"
          :data.sync="end_date"></admin-date-picker>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  export default {
    name: "PeriodPicker",
    created() {
      // this.start_date = moment().format('YYYY-MM-DD');
      // this.end_date = moment().format('YYYY-MM-DD');
    },
    data() {
      return {
        start_date: '',
        end_date: ''
      }
    },
    methods: {
      emit() {
        this.$emit('select', `start_date=${this.start_date}&end_date=${this.end_date}`);
      }
    },
    watch: {
      start_date() {
        this.emit();
      },
      end_date() {
        this.emit();
      }
    }
  }
</script>

<style lang="stylus" scoped>

</style>
